// The project being worked on, shared by Projects, Engineering Flow, HVAC
// Design and Room Builder. Each screen had its own picker, so moving from one
// to the next dropped the project and the reader picked it again — the flow
// broke at every hand-off. Per-viewer convenience only, so browser storage;
// a blocked storage just means each screen starts unpicked, as before.

const KEY = "kz.activeProject";
const OPEN = "kz.openProject";

export function getActiveProject() {
  try { return Number(localStorage.getItem(KEY)) || null; } catch { return null; }
}

export function setActiveProject(id) {
  try {
    if (id) localStorage.setItem(KEY, String(id));
    else localStorage.removeItem(KEY);
  } catch { /* storage blocked */ }
}

// Asked for by a "Go to Projects" from another screen: the Projects tab opens
// this project's page once, instead of the list.
export function requestOpenProject(id) {
  setActiveProject(id);
  try { sessionStorage.setItem(OPEN, String(id)); } catch { /* storage blocked */ }
}

export function takeOpenProject() {
  try {
    const v = Number(sessionStorage.getItem(OPEN)) || null;
    sessionStorage.removeItem(OPEN);
    return v;
  } catch { return null; }
}
